export interface FAQItem {
  question: string;
  answer: string;
}

export const getBlogFAQs = (slug: string, locale: string = 'fr'): FAQItem[] => {
  const faqs: Record<string, Record<string, FAQItem[]>> = {
    maintenance: {
      fr: [
        {
          question: "Pourquoi la maintenance industrielle est-elle importante ?",
          answer: "Elle prévient les pannes, optimise la production et réduit les coûts en évitant les arrêts imprévus."
        },
        {
          question: "Quels sont les types de maintenance ?",
          answer: "Maintenance corrective (après panne), préventive (anticipation) et prédictive (données)."
        },
        {
          question: "Qu'est-ce qu'une GMAO ?",
          answer: "Gestion de Maintenance Assistée par Ordinateur : logiciel pour planifier et analyser la maintenance."
        },
        {
          question: "Comment choisir un logiciel GMAO ?",
          answer: "Vérifiez simplicité, fonctionnalités, compatibilité, support et coût."
        },
      ],
      en: [
        {
          question: "Why is industrial maintenance important?",
          answer: "It prevents breakdowns, optimizes production, and reduces costs by avoiding unplanned downtime.",
        },
        {
          question: "What are the types of maintenance?",
          answer: "Corrective (after failure), preventive (scheduled), and predictive (data-driven).",
        },
        {
          question: "What is a CMMS?",
          answer: "Computerized Maintenance Management System: software to plan, track, and analyze maintenance operations.",
        },
        {
          question: "How to choose a CMMS software?",
          answer: "Check ease of use, features, compatibility, technical support, and cost.",
        },
      ],
      ar: [
        {
          question: "لماذا تعتبر الصيانة الصناعية مهمة؟",
          answer: "تمنع الأعطال، تحسن الإنتاج، وتقلل التكاليف بتجنب التوقف غير المخطط له.",
        },
        {
          question: "ما هي أنواع الصيانة؟",
          answer: "الصيانة التصحيحية (بعد العطل)، الوقائية (مجدولة)، والتنبؤية (بناءً على البيانات).",
        },
        {
          question: "ما هو نظام GMAO؟",
          answer: "نظام إدارة الصيانة بمساعدة الحاسوب: برنامج لتخطيط ومتابعة وتحليل عمليات الصيانة.",
        },
        {
          question: "كيف تختار برنامج GMAO؟",
          answer: "تحقق من سهولة الاستخدام، الميزات، التوافق، الدعم الفني، والتكلفة.",
        },
      ],
    },

    'traitement-eaux-usees-assainissement': {
      fr: [
        {
          question: "Qu'est-ce que le traitement des eaux usées ?",
          answer: "Éliminer les polluants avant rejet ou réutilisation pour protéger santé et environnement."
        },
        {
          question: "Quelles sont les étapes du traitement ?",
          answer: "Prétraitement, primaire, secondaire, tertiaire (filtration, décantation, bactéries, purification)."
        },
        {
          question: "Assainissement collectif ou autonome ?",
          answer: "Collectif (réseau public) ou autonome (fosse septique pour zones isolées)."
        },
        {
          question: "Quelles solutions modernes ?",
          answer: "Recyclage, technologies écologiques, systèmes intelligents de gestion d'eau."
        },
      ],
      en: [
        {
          question: "What is wastewater treatment?",
          answer: "Removing pollutants before discharge or reuse to protect health and the environment.",
        },
        {
          question: "What are the treatment steps?",
          answer: "Pretreatment, primary, secondary, tertiary (filtration, settling, bacteria, purification).",
        },
        {
          question: "Collective or autonomous sanitation?",
          answer: "Collective (public network) or autonomous (septic tank for isolated areas).",
        },
        {
          question: "What modern solutions exist?",
          answer: "Recycling, eco-friendly technologies, smart water management systems.",
        },
      ],
      ar: [
        {
          question: "ما هي معالجة المياه العادمة؟",
          answer: "إزالة الملوثات قبل الصرف أو إعادة الاستخدام لحماية الصحة والبيئة.",
        },
        {
          question: "ما هي مراحل المعالجة؟",
          answer: "ما قبل المعالجة، أولية، ثانوية، ثالثية (ترشيح، ترسيب، بكتيريا، تنقية).",
        },
        {
          question: "الصرف الصحي الجماعي أم المستقل؟",
          answer: "جماعي (شبكة عامة) أو مستقل (خزان صرف صحي للمناطق النائية).",
        },
        {
          question: "ما هي الحلول الحديثة؟",
          answer: "إعادة التدوير، تقنيات صديقة للبيئة، أنظمة ذكية لإدارة المياه.",
        },
      ],
    },

    'equipements-piscine': {
      fr: [
        {
          question: "Quels sont les équipements de base d’une piscine ?",
          answer: "Filtration, traitement de l’eau, accessoires de nettoyage et sécurité."
        },
        {
          question: " Quel est le meilleur système de filtration ?",
          answer: "Le filtre à sable est le plus utilisé pour son efficacité et son prix."
        },
        {
          question: " Comment garder une piscine propre ?",
          answer: "Grâce à une bonne filtration, un traitement régulier et des accessoires adaptés"
        },
      ],
      en: [
  {
    question: "What are the basic equipment for a swimming pool?",
    answer: "Filtration, water treatment, cleaning accessories, and safety equipment."
  },
  {
    question: "What is the best filtration system?",
    answer: "The sand filter is the most widely used for its efficiency and price."
  },
  {
    question: "How to keep a swimming pool clean?",
    answer: "Through good filtration, regular treatment, and suitable accessories."
  },
],
      ar: [
  {
    question: "ما هي المعدات الأساسية لحوض السباحة؟",
    answer: "الترشيح، معالجة المياه، ملحقات التنظيف، ومعدات الأمان."
  },
  {
    question: "ما هو أفضل نظام ترشيح؟",
    answer: "فلتر الرمل هو الأكثر استخداماً لكفاءته وسعره المناسب."
  },
  {
    question: "كيف تحافظ على نظافة حوض السباحة؟",
    answer: "من خلال ترشيح جيد، معالجة منتظمة، وملحقات مناسبة."
  },
],
    },

    renovation: {
      fr: [
        {
          question: "Pourquoi rénover un bâtiment ancien ?",
          answer: "Moderniser, sécurité, économie énergie, augmenter valeur bien."
        },
        {
          question: "Quelles étapes de rénovation ?",
          answer: "Diagnostic, planification, démolition, gros œuvre, finition."
        },
        {
          question: "Matériaux pour rénovation moderne ?",
          answer: "Béton renforcé, acier, bois, isolants écologiques."
        },
        {
          question: "Avantages rénovation vs neuf ?",
          answer: "Coûts réduits, valorise patrimoine, confort amélioré, environnement respecté."
        },
      ],
      en: [
        {
          question: "Why renovate an old building?",
          answer: "Modernize, improve safety, save energy, increase property value.",
        },
        {
          question: "What are the renovation steps?",
          answer: "Assessment, planning, demolition, structural work, finishing.",
        },
        {
          question: "Materials for modern renovation?",
          answer: "Reinforced concrete, steel, wood, eco-friendly insulation.",
        },
        {
          question: "Renovation vs new build advantages?",
          answer: "Lower costs, enhances heritage, improved comfort, environmentally friendly.",
        },
      ],
      ar: [
        {
          question: "لماذا تجديد مبنى قديم؟",
          answer: "تحديث، تحسين السلامة، توفير الطاقة، زيادة قيمة العقار.",
        },
        {
          question: "ما هي خطوات التجديد؟",
          answer: "تقييم، تخطيط، هدم، أعمال هيكلية، تشطيب.",
        },
        {
          question: "مواد التجديد الحديث؟",
          answer: "خرسانة مسلحة، فولاذ، خشب، عزل صديق للبيئة.",
        },
        {
          question: "مزايا التجديد مقابل البناء الجديد؟",
          answer: "تكاليف أقل، يحافظ على التراث، راحة محسنة، صديق للبيئة.",
        },
      ],
    },

    'industrial-supply': {
      fr: [
        {
          question: "Quels types de fournitures industrielles ?",
          answer: "Production, maintenance, pièces rechange, consommables, sécurité."
        },
        {
          question: "Comment choisir fournitures qualité ?",
          answer: "Matériaux, fiabilité fournisseur, compatibilité, qualité/prix, disponibilité."
        },
        {
          question: "Où trouver fournitures fiables ?",
          answer: "Fournisseurs spécialisés, distributeurs industriels, plateformes pros."
        },
        {
          question: "Avantages bonnes fournitures ?",
          answer: "Productivité, moins pannes, coûts optimisés, longévité équipements."
        },
      ],
      en: [
        {
          question: "What types of industrial supplies?",
          answer: "Production, maintenance, spare parts, consumables, safety.",
        },
        {
          question: "How to choose quality supplies?",
          answer: "Materials, supplier reliability, compatibility, value for money, availability.",
        },
        {
          question: "Where to find reliable supplies?",
          answer: "Specialized suppliers, industrial distributors, professional platforms.",
        },
        {
          question: "Benefits of good supplies?",
          answer: "Productivity, fewer breakdowns, optimized costs, equipment longevity.",
        },
      ],
      ar: [
        {
          question: "ما أنواع اللوازم الصناعية؟",
          answer: "إنتاج، صيانة، قطع غيار، مستهلكات، سلامة.",
        },
        {
          question: "كيف تختار لوازم عالية الجودة؟",
          answer: "المواد، موثوقية المورد، التوافق، قيمة مقابل المال، التوفر.",
        },
        {
          question: "أين تجد لوازم موثوقة؟",
          answer: "موردين متخصصين، موزعين صناعيين، منصات مهنية.",
        },
        {
          question: "فوائد اللوازم الجيدة؟",
          answer: "إنتاجية، أعطال أقل، تكاليف محسنة، عمر أطول للمعدات.",
        },
      ],
    },

    'air-compressors': {
      fr: [
        {
          question: "Comment fonctionne un compresseur d'air ?",
          answer: "Aspiration d'air extérieur → compression dans un réservoir → augmentation de la pression → libération selon les besoins."
        },
        {
          question: "Quels sont les types de compresseurs d'air ?",
          answer: "Piston (ateliers), vis (utilisation continue), centrifuge (grandes industries), portable (petits besoins)."
        },
        {
          question: "Comment choisir un compresseur d'air ?",
          answer: "Puissance, débit, pression, usage, consommation énergétique."
        },
        {
          question: "Entretien d'un compresseur d'air ?",
          answer: "Vérifier le niveau d'huile, nettoyer les filtres, contrôler la pression, purger le réservoir."
        },
      ],
      en: [
        {
          question: "How does an air compressor work?",
          answer: "Draws in outside air → compresses it in a tank → pressure increases → releases as needed."
        },
        {
          question: "What are the types of air compressors?",
          answer: "Piston (workshops), screw (continuous use), centrifugal (large industries), portable (small needs)."
        },
        {
          question: "How to choose an air compressor?",
          answer: "Power, flow rate, pressure, usage, energy consumption."
        },
        {
          question: "Air compressor maintenance?",
          answer: "Check oil level, clean filters, check pressure, drain the tank."
        },
      ],
      ar: [
        {
          question: "كيف يعمل ضاغط الهواء؟",
          answer: "سحب هواء خارجي → ضغطه في خزان → زيادة الضغط → تحرير حسب الحاجة."
        },
        {
          question: "ما هي أنواع ضواغط الهواء؟",
          answer: "مكبس (ورش)، لولبي (استخدام مستمر)، طرد مركزي (صناعات كبيرة)، محمول (احتياجات صغيرة)."
        },
        {
          question: "كيف تختار ضاغط هواء؟",
          answer: "الطاقة، معدل التدفق، الضغط، الاستخدام، استهلاك الطاقة."
        },
        {
          question: "صيانة ضاغط الهواء؟",
          answer: "فحص مستوى الزيت، تنظيف الفلاتر، التحقق من الضغط، تفريغ الخزان."
        },
      ],
    },

    'maintenance-gmao': {
      fr: [
        {
          question: "Qu'est-ce qu'une GMAO ?",
          answer: "Gestion de Maintenance Assistée par Ordinateur : digitalise et optimise les opérations de maintenance."
        },
        {
          question: "Comment fonctionne une GMAO ?",
          answer: "Enregistrement des équipements, planification des interventions, suivi des pannes, analyse des performances."
        },
        {
          question: "Quels sont les avantages d'une GMAO ?",
          answer: "Meilleure organisation, gain de temps pour les techniciens, historique des équipements, productivité accrue."
        },
        {
          question: "Dans quels secteurs utiliser une GMAO ?",
          answer: "Industrie manufacturière, énergie, BTP, agroalimentaire, hôpitaux."
        },
      ],
      en: [
        {
          question: "What is a CMMS?",
          answer: "Computerized Maintenance Management System: digitizes and optimizes maintenance operations."
        },
        {
          question: "How does a CMMS work?",
          answer: "Equipment registration, intervention scheduling, fault tracking, performance analysis."
        },
        {
          question: "What are the benefits of a CMMS?",
          answer: "Better organization, time savings for technicians, equipment history, increased productivity."
        },
        {
          question: "Which sectors use CMMS?",
          answer: "Manufacturing, energy, construction, food industry, hospitals."
        },
      ],
      ar: [
        {
          question: "ما هو نظام GMAO؟",
          answer: "نظام إدارة الصيانة بمساعدة الحاسوب: رقمي ويحسن عمليات الصيانة."
        },
        {
          question: "كيف يعمل نظام GMAO؟",
          answer: "تسجيل المعدات، جدولة التدخلات، تتبع الأعطال، تحليل الأداء."
        },
        {
          question: "ما هي فوائد نظام GMAO؟",
          answer: "تنظيم أفضل، توفير الوقت للفنيين، تاريخ المعدات، زيادة الإنتاجية."
        },
        {
          question: "في أي قطاعات يستخدم نظام GMAO؟",
          answer: "الصناعة التحويلية، الطاقة، البناء، الصناعات الغذائية، المستشفيات."
        },
      ],
    },

    'electrical-works': {
      fr: [
          {
          question: "Quels sont les travaux d’électricité les plus courants ?",
          answer: " Les plus courants sont l’installation électrique, le dépannage, la maintenance et la mise aux normes des installations."
        },
        {
          question: "Quelles sont les normes électriques à respecter ?",
          answer: " Les normes assurent la sécurité des personnes et des installations contre les courts-circuits, surcharges et incendies."
        },
        {
          question: " Quels sont les risques d’une mauvaise installation électrique ?",
          answer: " Les principaux risques sont les courts-circuits, les incendies, les pannes fréquentes et les électrocutions."
        },
      ],
     en: [
  {
    question: "What are the most common electrical works?",
    answer: "The most common are electrical installation, troubleshooting, maintenance, and bringing installations up to standard."
  },
  {
    question: "What electrical standards must be respected?",
    answer: "Standards ensure the safety of people and installations against short circuits, overloads, and fires."
  },
  {
    question: "What are the risks of a poor electrical installation?",
    answer: "The main risks are short circuits, fires, frequent breakdowns, and electrocutions."
  },
],
      ar: [
  {
    question: "ما هي أعمال الكهرباء الأكثر شيوعاً؟",
    answer: "الأكثر شيوعاً هي التركيبات الكهربائية، إصلاح الأعطال، الصيانة، وتحديث التركيبات لتتوافق مع المعايير."
  },
  {
    question: "ما هي المعايير الكهربائية التي يجب احترامها؟",
    answer: "المعايير تضمن سلامة الأشخاص والتركيبات ضد الدوائر القصيرة، الأحمال الزائدة، والحرائق."
  },
  {
    question: "ما هي مخاطر التركيبات الكهربائية الرديئة؟",
    answer: "المخاطر الرئيسية هي الدوائر القصيرة، الحرائق، الأعطال المتكررة، والصعق الكهربائي."
  },
],
    },
  };

  // Retourne les FAQs pour le slug et la locale donnés, ou un tableau vide si non trouvé
  return faqs[slug]?.[locale] || [];
};
